import "whatwg-fetch"; // polyfill for older browsers

import {
  getAPIConfig,
  convertQueryObjToString,
  handleAPIResponse,
} from "@utils/browser-helpers";
import { executeAPIRequest } from "@adapters/api";

var promotionsAdapter = {
  fetchIndividualPromotion: async (promotionId) => {
    let route = `/promotion/id/${promotionId}`;
    const apiConfig = getAPIConfig(route);
    const response = await executeAPIRequest(apiConfig, "GET");
    const responseData = await response.json();
    return handleAPIResponse(responseData);
  },

  fetchPromotions: async (fetchConfig) => {
    let route = `/promotion${
      fetchConfig ? `${convertQueryObjToString(fetchConfig, true)}` : ""
    }`;
    const apiConfig = getAPIConfig(route);
    const response = await executeAPIRequest(apiConfig, "GET");
    const responseData = await response.json();
    return handleAPIResponse(responseData);
  },

  postPromotion: async (payload) => {
    const route = `/promotion`;
    const apiConfig = getAPIConfig(route);
    const response = await executeAPIRequest(apiConfig, "POST", null, payload);
    const responseData = await response.json();
    return handleAPIResponse(responseData);
  },

  patchPromotion: async (grpid, changes) => {
    const route = `/promotion/id/${grpid}`;
    const apiConfig = getAPIConfig(route);
    const response = await executeAPIRequest(apiConfig, "PATCH", null, changes);
    const responseData = await response.json();
    return handleAPIResponse(responseData);
  },

  fetchCTIDOffers: async (ctid) => {
    const route = `/promotion/live?import_ctid=${ctid}`;
    const apiConfig = getAPIConfig(route);
    const response = await executeAPIRequest(apiConfig, "GET");
    const responseData = await response.json();
    return handleAPIResponse(responseData);
  },
};

window.promotionsAdapter = promotionsAdapter;

export default promotionsAdapter;
